import { cn } from '@/lib/utils';
const logoImage = '/logo.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showText?: boolean;
}

export const Logo = ({ size = 'md', className, showText = false }: LogoProps) => {
  const sizes = {
    sm: { class: 'w-8 h-8', width: 32, height: 32 },
    md: { class: 'w-10 h-10', width: 40, height: 40 },
    lg: { class: 'w-14 h-14', width: 56, height: 56 }
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  const sizeConfig = sizes[size];

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img 
        src={logoImage} 
        alt="LOWKEYX Logo" 
        width={sizeConfig.width}
        height={sizeConfig.height}
        className={cn("object-contain", sizeConfig.class)}
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />

      {showText && (
        <span className={cn("font-display font-bold", textSizes[size])}>
          LOWKEY<span className="text-primary">X</span>
        </span>
      )}
    </div>
  );
};
